module.exports = __webpack_public_path__ + "img/bpBJRed.40812859.jpg";